"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Comparison() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="new-vs-used-mechanical-bulls" data-nav="light" className="relative bg-background text-foreground py-14 md:py-16 border-y border-border">
      <div id="newvsusedmechanicalbulls" className="sr-only" aria-hidden="true" />
      
      <div className="container mx-auto px-4 sm:px-6 max-w-5xl">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-40px"
      }} transition={{
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="bg-card text-card-foreground border border-border p-6 sm:p-10 md:p-12 shadow-xs">
          <div className="border-b border-border pb-6 mb-6">
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold uppercase tracking-tight text-foreground">
              New vs Used Mechanical Bulls
            </h2>
          </div>

          <div className="space-y-4 max-w-3xl text-muted-foreground text-base sm:text-lg leading-relaxed">
            <p>
              New equipment is not automatically the right choice for every buyer. A new mechanical bull may suit you when you want a known starting condition and current product information. A used machine may make more sense when lowering the initial purchase cost is the priority and the exact unit has enough condition information to evaluate it properly.
            </p>
            <p className="text-foreground font-medium">
              Instead of treating one option as universally better, compare the actual machines available.
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-border flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
            <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-none h-12 px-6 font-serif font-bold tracking-wider uppercase text-base transition-colors">
              <Link to="#product-catalog" className="inline-flex items-center justify-center gap-2">
                <span>SHOP NEW BULLS</span>
                <ArrowUpRight className="size-4" />
              </Link>
            </Button>

            <Button asChild variant="outline" className="bg-transparent border border-foreground text-foreground hover:bg-muted hover:text-foreground rounded-none h-12 px-6 font-serif font-bold tracking-wider uppercase text-base transition-colors">
              <Link to="/UsedMechanicalBullsPage" className="inline-flex items-center justify-center gap-2">
                <span>VIEW USED BULLS</span>
                <ArrowUpRight className="size-4" />
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}